import React from 'react';
import { Box, Skeleton } from '@mui/material';

const PageSkeletonCustomers = () => {
  return (
    <Box sx={{ width: '100%' }}>
      {/* <Skeleton variant="text" width="150px" height={40} sx={{ mb: 3, bgcolor: '#E6EDF9' }} /> */}
      
      <Box sx={{ 
        border: '1px solid #E4EBF6',
        borderRadius: '8px',
        bgcolor: 'white',
        padding: '20px',
        overflow: 'hidden'
      }}>
        {/* Table Header */}
        <Box sx={{ display: 'flex', mb: 3, px: 2 }}>
          <Skeleton variant="text" width="25%" height={24} sx={{ bgcolor: '#E6EDF9' }} />
          <Skeleton variant="text" width="20%" height={24} sx={{ ml: 2, bgcolor: '#E6EDF9' }} />
          <Skeleton variant="text" width="15%" height={24} sx={{ ml: 2, bgcolor: '#E6EDF9' }} />
          <Skeleton variant="text" width="20%" height={24} sx={{ ml: 2, bgcolor: '#E6EDF9' }} />
          <Skeleton variant="text" width="15%" height={24} sx={{ ml: 2, bgcolor: '#E6EDF9' }} />
        </Box>

        {/* Table Rows */}
        {[1, 2, 3, 4, 5].map((item) => (
          <Box key={item} sx={{ display: 'flex', mb: 3, px: 2, alignItems: 'center' }}>
            <Box sx={{ width: '25%' }}>
              <Skeleton variant="text" width="80%" height={20} sx={{ bgcolor: '#E6EDF9' }} />
              <Skeleton variant="text" width="60%" height={16} sx={{ bgcolor: '#E6EDF9' }} />
            </Box>
            <Skeleton variant="text" width="18%" height={20} sx={{ ml: 2, bgcolor: '#E6EDF9' }} />
            <Skeleton variant="text" width="13%" height={20} sx={{ ml: 2, bgcolor: '#E6EDF9' }} />
            <Skeleton variant="text" width="18%" height={20} sx={{ ml: 2, bgcolor: '#E6EDF9' }} />
            <Skeleton variant="rectangular" width="70px" height={24} sx={{ ml: 2, borderRadius: 1, bgcolor: '#E6EDF9' }} />
            <Skeleton variant="circular" width={24} height={24} sx={{ ml: 'auto', bgcolor: '#E6EDF9' }} />
          </Box>
        ))}

        {/* Pagination */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, px: 2 }}>
          <Skeleton variant="text" width={200} height={40} sx={{ bgcolor: '#E6EDF9' }} />
        </Box>
      </Box>
    </Box>
  );
};

export default PageSkeletonCustomers;
